/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

export const data = {
  img: "https://i.ibb.co/qgs6JDC/shreedigital-listed-asset-description-750-700.png",
  title: "Listed Assets",
  description:
    "In this section you can view the assets that are listed by you / your organisation in different Shree Digital supported marketplace.",
  meta: [
    {
      key: "",
      value: "From this section, you can,",
    },
    {
      key: "",
      value: "• Edit the listed Price",
    },
    {
      key: "",
      value: "• Unlist from marketplace",
    },
    {
      key:
        "",
      value: "• List in Crypto / FIAT currencies ",
    },
    {
      key: "",
      value: "- Read More",
    },
    {
      key: "",
      value: "• Listed Assets - Grid View",
      path: "/listed-assets",
    },
    {
      key: "",
      value: "• Listed Assets - Table View",
      path: "/listed-assets-table",
    },
   
  ],
  // buttons: [
  //   {
  //     key: "edit",
  //     title: "Edit",
  //   },
  // ],
  };